export default "__VITE_ASSET__oqKLWBIg__"